// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import axios from 'axios';
// import { host } from '../script/variables';

// // ─── Formatters ───────────────────────────────────────────────────────────────
// const fmt = (n) =>
//   new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n ?? 0);

// const fmtDate = (s) =>
//   new Date(s).toLocaleString('en-IN', {
//     day: '2-digit', month: 'short', year: 'numeric',
//     hour: '2-digit', minute: '2-digit', hour12: true,
//   });

// const fmtShortDate = (s) =>
//   new Date(s).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });

// // ─── Axios instance with partner token ───────────────────────────────────────
// // Partner token is read from localStorage (set at login time).
// // Key name: 'partnertoken' — adjust to match your auth store/context.
// const getpartnertoken = () =>
//   localStorage.getItem('partnertoken') || sessionStorage.getItem('partnertoken') || '';

// const authAxios = axios.create();

// // Attach token on every request; re-reads storage so it always uses latest value
// authAxios.interceptors.request.use((config) => {
//   const token = getpartnertoken();
//   if (token) config.headers['Authorization'] = `${token}`;
//   return config;
// });

// // Redirect to login on 401
// authAxios.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (err?.response?.status === 401) {
//       // Adjust redirect path to match your router setup
//       window.location.href = '/partner/login';
//     }
//     return Promise.reject(err);
//   }
// );

// // ─── API factory — cafeId is baked in per component mount ────────────────────
// // All payloads go in the request body (POST), never in query params.
// const BASE = `${host}/payment/settlement`;

// const makeApi = (cafeId) => ({
//   summary: (payload) => authAxios.post(`${BASE}/summary`, { ...payload, cafeId }),
//   withdraw: (amount)  => authAxios.post(`${BASE}/withdraw`, { amount, cafeId }),
// });

// // ─── Sparkline SVG ────────────────────────────────────────────────────────────
// const Sparkline = ({ data = [], color = '#16a34a', height = 36 }) => {
//   if (!data.length) return null;
//   const W = 120, H = height;
//   const vals = data.map((d) => d.settled + d.pending);
//   const max = Math.max(...vals, 1);
//   const pts = vals.map((v, i) => {
//     const x = (i / (vals.length - 1 || 1)) * W;
//     const y = H - (v / max) * (H - 4);
//     return `${x},${y}`;
//   });
//   const area = `M${pts.join(' L')} L${W},${H} L0,${H} Z`;
//   const line = `M${pts.join(' L')}`;
//   return (
//     <svg width={W} height={H} style={{ overflow: 'visible' }}>
//       <defs>
//         <linearGradient id={`sg-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
//           <stop offset="0%" stopColor={color} stopOpacity="0.18" />
//           <stop offset="100%" stopColor={color} stopOpacity="0" />
//         </linearGradient>
//       </defs>
//       <path d={area} fill={`url(#sg-${color.replace('#', '')})`} />
//       <path d={line} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );
// };

// // ─── BarChart ─────────────────────────────────────────────────────────────────
// const BarChart = ({ data = [] }) => {
//   if (!data.length) return <p style={s.empty}>No chart data</p>;
//   const max = Math.max(...data.map((d) => d.settled + d.pending), 1);
//   return (
//     <div style={s.chartWrap}>
//       <div style={s.chartBars}>
//         {data.map((d, i) => {
//           const total = d.settled + d.pending;
//           const sh = ((d.settled / max) * 100).toFixed(1);
//           const ph = ((d.pending / max) * 100).toFixed(1);
//           return (
//             <div key={i} style={s.barGroup} title={`${fmtShortDate(d.date + 'T00:00:00')}\nSettled: ${fmt(d.settled)}\nPending: ${fmt(d.pending)}`}>
//               <div style={{ ...s.barStack, height: '100%' }}>
//                 <div style={{ flex: 1 }} />
//                 <div style={{ ...s.barPending, height: `${ph}%` }} />
//                 <div style={{ ...s.barSettled, height: `${sh}%` }} />
//               </div>
//               <span style={s.barLabel}>{fmtShortDate(d.date + 'T00:00:00')}</span>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ─── Badge ────────────────────────────────────────────────────────────────────
// const Badge = ({ status }) => {
//   const cfg = {
//     settled: { bg: '#dcfce7', color: '#15803d', label: 'Settled' },
//     pending: { bg: '#fef9c3', color: '#a16207', label: 'Pending' },
//   }[status] ?? { bg: '#f1f5f9', color: '#64748b', label: '—' };
//   return (
//     <span style={{ ...s.badge, background: cfg.bg, color: cfg.color }}>
//       {cfg.label}
//     </span>
//   );
// };

// // ─── Metric Card ──────────────────────────────────────────────────────────────
// const MetricCard = ({ label, value, sub, color = '#0f172a', chart }) => (
//   <div style={s.metricCard}>
//     <div style={s.metricTop}>
//       <span style={s.metricLabel}>{label}</span>
//       {chart && <Sparkline data={chart} color={color} />}
//     </div>
//     <div style={{ ...s.metricValue, color }}>{value}</div>
//     {sub && <div style={s.metricSub}>{sub}</div>}
//   </div>
// );

// // ─── Skeleton ─────────────────────────────────────────────────────────────────
// const Skeleton = ({ w = '100%', h = 16, r = 6 }) => (
//   <div style={{ width: w, height: h, borderRadius: r, background: 'linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.4s infinite' }} />
// );

// // ─── Modal ────────────────────────────────────────────────────────────────────
// const WithdrawModal = ({ available, onClose, onSuccess, api }) => {
//   const [amount, setAmount] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const inputRef = useRef(null);

//   useEffect(() => { inputRef.current?.focus(); }, []);

//   const handleSubmit = async () => {
//     const val = parseFloat(amount);
//     if (!val || val <= 0) return setError('Enter a valid amount');
//     if (val > available) return setError(`Cannot exceed available balance ${fmt(available)}`);
//     setError('');
//     setLoading(true);
//     try {
//       const { data } = await api.withdraw(val);
//       onSuccess(data.data);
//     } catch (e) {
//       setError(e?.response?.data?.message || 'Request failed. Try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKey = (e) => { if (e.key === 'Enter') handleSubmit(); if (e.key === 'Escape') onClose(); };

//   return (
//     <div style={s.modalOverlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
//       <div style={s.modal} role="dialog" aria-modal="true" aria-label="Request withdrawal">
//         <div style={s.modalHeader}>
//           <span style={s.modalTitle}>Request withdrawal</span>
//           <button style={s.closeBtn} onClick={onClose} aria-label="Close">✕</button>
//         </div>
//         <div style={s.modalBody}>
//           <div style={s.availRow}>
//             <span style={s.availLabel}>Available balance</span>
//             <span style={s.availAmt}>{fmt(available)}</span>
//           </div>
//           <label style={s.inputLabel}>Withdrawal amount</label>
//           <div style={s.inputWrap}>
//             <span style={s.inputPrefix}>₹</span>
//             <input
//               ref={inputRef}
//               type="number"
//               min="1"
//               max={available}
//               step="1"
//               placeholder="Enter amount"
//               value={amount}
//               onChange={(e) => { setAmount(e.target.value); setError(''); }}
//               onKeyDown={handleKey}
//               style={s.input}
//             />
//           </div>
//           {error && <p style={s.errorText}>{error}</p>}
//           <p style={s.modalNote}>Funds typically arrive within 1–2 business days.</p>
//         </div>
//         <div style={s.modalFooter}>
//           <button style={s.btnSecondary} onClick={onClose} disabled={loading}>Cancel</button>
//           <button style={{ ...s.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={handleSubmit} disabled={loading}>
//             {loading ? 'Submitting…' : 'Confirm request'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Toast ────────────────────────────────────────────────────────────────────
// const Toast = ({ message, type = 'success', onDone }) => {
//   useEffect(() => { const t = setTimeout(onDone, 3500); return () => clearTimeout(t); }, [onDone]);
//   return (
//     <div style={{ ...s.toast, ...(type === 'error' ? s.toastError : s.toastSuccess) }}>
//       <span>{type === 'success' ? '✓' : '✗'}</span>
//       <span>{message}</span>
//     </div>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// const FILTERS = [
//   { key: 'today',     label: 'Today' },
//   { key: 'yesterday', label: 'Yesterday' },
//   { key: 'week',      label: 'This week' },
//   { key: 'month',     label: 'This month' },
//   { key: 'custom',    label: 'Custom' },
// ];

// const STATUS_TABS = [
//   { key: 'all',     label: 'All' },
//   { key: 'settled', label: 'Settled' },
//   { key: 'pending', label: 'Pending' },
// ];

// const PAGE_SIZES = [10, 20, 50];

// const PaymentGatewaySettlement = ({ cafeid }) => {
//   // ── cafeId comes from parent prop: <PaymentGatewaySettlement cafeid={cafeid} />
//   const cafeId = cafeid;

//   // ── Memoised API instance — recreated only when cafeId changes
//   // useMemo returns the value directly; useCallback would return a function
//   const api = React.useMemo(() => makeApi(cafeId), [cafeId]);

//   const [period, setPeriod]         = useState('week');
//   const [from, setFrom]             = useState('');
//   const [to, setTo]                 = useState('');
//   const [status, setStatus]         = useState('all');
//   const [page, setPage]             = useState(1);
//   const [limit, setLimit]           = useState(20);
//   const [data, setData]             = useState(null);
//   const [loading, setLoading]       = useState(false);
//   const [error, setError]           = useState('');
//   const [showModal, setShowModal]   = useState(false);
//   const [toast, setToast]           = useState(null);

//   // ── Fetch — defined unconditionally; guard inside callback
//   const fetchData = useCallback(async () => {
//     if (!cafeId) return;
//     if (period === 'custom' && (!from || !to)) return;
//     setLoading(true);
//     setError('');
//     try {
//       const params = { period, status, page, limit };
//       if (period === 'custom') { params.from = from; params.to = to; }
//       const res = await api.summary(params);
//       setData(res.data.data);
//     } catch (e) {
//       setError(e?.response?.data?.message || 'Failed to load settlements. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   }, [cafeId, period, from, to, status, page, limit]);

//   useEffect(() => { setPage(1); }, [period, from, to, status, limit]);
//   useEffect(() => { fetchData(); }, [fetchData]);

//   // ── Guard rendered AFTER all hooks — never early-return before hooks
//   if (!cafeId) {
//     return (
//       <div style={{ padding: '2rem', color: '#dc2626', fontFamily: 'sans-serif' }}>
//         No cafe ID provided. Pass <code>cafeid</code> as a prop.
//       </div>
//     );
//   }

//   const handlePeriod = (p) => { setPeriod(p); if (p !== 'custom') { setFrom(''); setTo(''); } };

//   const handleWithdrawSuccess = (result) => {
//     setShowModal(false);
//     setToast({ type: 'success', message: `Withdrawal of ${fmt(result.requestedAmount)} submitted!` });
//     fetchData();
//   };

//   const { stats = {}, transactions = [], pagination = {}, chartData = [] } = data ?? {};

//   return (
//     <div style={s.page}>
//       {/* ── Global shimmer keyframe */}
//       <style>{`@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>

//       {/* ── Header */}
//       <div style={s.header}>
//         <div>
//           {/* <h1 style={s.pageTitle}>Gateway settlements</h1> */}
//           <p style={s.pageSubtitle}>Cashfree · Cafe ID: {cafeId}</p>
//         </div>
//         <button
//           style={s.withdrawTrigger}
//           onClick={() => setShowModal(true)}
//           disabled={!stats.availableBalance}
//           title={!stats.availableBalance ? 'No balance available' : ''}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" style={{ marginRight: 6 }}>
//             <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
//           </svg>
//           Request withdrawal
//         </button>
//       </div>

//       {/* ── Period filters */}
//       <div style={s.filterRow}>
//         {FILTERS.map((f) => (
//           <button
//             key={f.key}
//             style={{ ...s.chip, ...(period === f.key ? s.chipActive : {}) }}
//             onClick={() => handlePeriod(f.key)}
//           >
//             {f.label}
//           </button>
//         ))}
//       </div>

//       {/* ── Custom date range */}
//       {period === 'custom' && (
//         <div style={s.dateRow}>
//           <div style={s.dateField}>
//             <label style={s.dateLabel}>From</label>
//             <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={s.dateInput} max={to || undefined} />
//           </div>
//           <div style={s.dateSep}>→</div>
//           <div style={s.dateField}>
//             <label style={s.dateLabel}>To</label>
//             <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={s.dateInput} min={from || undefined} />
//           </div>
//         </div>
//       )}

//       {/* ── Error */}
//       {error && (
//         <div style={s.errorBanner}>
//           <span>⚠ {error}</span>
//           <button style={s.retryBtn} onClick={fetchData}>Retry</button>
//         </div>
//       )}

//       {/* ── Metric cards */}
//       <div style={s.metricsGrid}>
//         {loading ? (
//           [1,2,3,4].map((k) => (
//             <div key={k} style={s.metricCard}>
//               <Skeleton w="60%" h={11} /><br />
//               <Skeleton w="80%" h={28} r={4} /><br />
//               <Skeleton w="40%" h={11} />
//             </div>
//           ))
//         ) : (
//           <>
//             <MetricCard label="Total collected"      value={fmt(stats.totalCollected)}   sub={`${stats.totalTransactions ?? 0} transactions`} color="#0f172a" chart={chartData} />
//             <MetricCard label="Settled"              value={fmt(stats.settledAmount)}    sub={`${stats.settledCount ?? 0} payments`}          color="#15803d" chart={chartData} />
//             <MetricCard label="Pending settlement"   value={fmt(stats.pendingAmount)}    sub={`${stats.pendingCount ?? 0} payments`}          color="#b45309" chart={chartData} />
//             <MetricCard label="Withdrawable balance" value={fmt(stats.availableBalance)} sub="After ~3% gateway fee"                          color="#1d4ed8" chart={chartData} />
//           </>
//         )}
//       </div>

//       {/* ── Bar chart */}
//       {!loading && chartData.length > 0 && (
//         <div style={s.chartCard}>
//           <div style={s.chartHeader}>
//             <span style={s.chartTitle}>Daily volume</span>
//             <div style={s.legend}>
//               <span style={{ ...s.legendDot, background: '#16a34a' }} />Settled
//               <span style={{ ...s.legendDot, background: '#eab308', marginLeft: 12 }} />Pending
//             </div>
//           </div>
//           <BarChart data={chartData} />
//         </div>
//       )}

//       {/* ── Table */}
//       <div style={s.tableCard}>
//         {/* Table header row */}
//         <div style={s.tableTopRow}>
//           {/* Status tabs */}
//           <div style={s.tabs}>
//             {STATUS_TABS.map((t) => (
//               <button key={t.key} style={{ ...s.tab, ...(status === t.key ? s.tabActive : {}) }} onClick={() => setStatus(t.key)}>
//                 {t.label}
//               </button>
//             ))}
//           </div>
//           {/* Page size */}
//           <div style={s.pageSizeRow}>
//             <span style={s.pageSizeLabel}>Rows</span>
//             <select value={limit} onChange={(e) => setLimit(Number(e.target.value))} style={s.select}>
//               {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
//             </select>
//           </div>
//         </div>

//         {/* Table */}
//         <div style={s.tableWrap}>
//           <table style={s.table}>
//             <thead>
//               <tr>
//                 {['Order ID','Amount','Method','CF Payment ID','Completed at','Settlement'].map((h) => (
//                   <th key={h} style={s.th}>{h}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 Array.from({ length: 5 }).map((_, i) => (
//                   <tr key={i}>
//                     {[1,2,3,4,5,6].map((c) => (
//                       <td key={c} style={s.td}><Skeleton w={c === 1 ? '90%' : c === 2 ? '50%' : '70%'} /></td>
//                     ))}
//                   </tr>
//                 ))
//               ) : transactions.length === 0 ? (
//                 <tr>
//                   <td colSpan={6} style={{ ...s.td, textAlign: 'center', padding: '2.5rem', color: '#94a3b8' }}>
//                     No gateway payments found for this period
//                   </td>
//                 </tr>
//               ) : (
//                 transactions.map((p) => (
//                   <tr key={p._id} style={s.tr}>
//                     <td style={{ ...s.td, ...s.mono, color: '#475569' }}>{p.order_id}</td>
//                     <td style={{ ...s.td, fontWeight: 600 }}>{fmt(p.totalAmount)}</td>
//                     <td style={s.td}>
//                       {Object.keys(p.paymentMethods ?? {}).map((m) => (
//                         <span key={m} style={s.methodChip}>{m.toUpperCase()}</span>
//                       ))}
//                     </td>
//                     <td style={{ ...s.td, ...s.mono, color: '#64748b' }}>{p.cf_payment_id}</td>
//                     <td style={{ ...s.td, color: '#64748b', whiteSpace: 'nowrap' }}>{fmtDate(p.payment_completion_time)}</td>
//                     <td style={s.td}><Badge status={p.gateway_settlement_status} /></td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {pagination.totalPages > 1 && (
//           <div style={s.pagination}>
//             <span style={s.paginationInfo}>
//               Showing {((page - 1) * limit) + 1}–{Math.min(page * limit, pagination.total)} of {pagination.total}
//             </span>
//             <div style={s.paginationBtns}>
//               <button style={s.pgBtn} disabled={!pagination.hasPrev || loading} onClick={() => setPage((p) => p - 1)}>← Prev</button>
//               {Array.from({ length: pagination.totalPages }, (_, i) => i + 1)
//                 .filter((p) => p === 1 || p === pagination.totalPages || Math.abs(p - page) <= 1)
//                 .reduce((acc, p, i, arr) => {
//                   if (i > 0 && p - arr[i - 1] > 1) acc.push('…');
//                   acc.push(p);
//                   return acc;
//                 }, [])
//                 .map((p, i) =>
//                   p === '…'
//                     ? <span key={`e${i}`} style={s.pgEllipsis}>…</span>
//                     : <button key={p} style={{ ...s.pgBtn, ...(p === page ? s.pgBtnActive : {}) }} onClick={() => setPage(p)}>{p}</button>
//                 )}
//               <button style={s.pgBtn} disabled={!pagination.hasNext || loading} onClick={() => setPage((p) => p + 1)}>Next →</button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── Withdraw modal */}
//       {showModal && (
//         <WithdrawModal
//           available={stats.availableBalance ?? 0}
//           onClose={() => setShowModal(false)}
//           onSuccess={handleWithdrawSuccess}
//           api={api}
//         />
//       )}

//       {/* ── Toast */}
//       {toast && <Toast {...toast} onDone={() => setToast(null)} />}
//     </div>
//   );
// };

// // ─── Styles ───────────────────────────────────────────────────────────────────
// const s = {
//   page:            { fontFamily: "'DM Sans', sans-serif", padding: '1.75rem', maxWidth: 1140, margin: '0 auto', color: '#0f172a' },
//   header:          { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: '1.5rem' },
//   pageTitle:       { fontSize: 22, fontWeight: 600, letterSpacing: '-0.4px', margin: 0 },
//   pageSubtitle:    { fontSize: 13, color: '#64748b', marginTop: 3 },
//   withdrawTrigger: { display: 'flex', alignItems: 'center', background: '#15803d', color: '#fff', border: 'none', borderRadius: 10, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', letterSpacing: '-0.1px', transition: 'opacity .15s' },
//   filterRow:       { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: '1.25rem' },
//   chip:            { padding: '6px 16px', borderRadius: 20, fontSize: 12, fontWeight: 500, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer', transition: 'all .15s' },
//   chipActive:      { background: '#0f172a', color: '#fff', borderColor: '#0f172a' },
//   dateRow:         { display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.25rem', flexWrap: 'wrap' },
//   dateField:       { display: 'flex', flexDirection: 'column', gap: 4 },
//   dateLabel:       { fontSize: 11, color: '#94a3b8', fontWeight: 600, letterSpacing: '0.4px', textTransform: 'uppercase' },
//   dateInput:       { border: '1px solid #e2e8f0', borderRadius: 8, padding: '7px 10px', fontSize: 13, color: '#0f172a', background: '#fff', outline: 'none' },
//   dateSep:         { color: '#94a3b8', fontSize: 16, marginTop: 18 },
//   errorBanner:     { display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 16px', fontSize: 13, color: '#dc2626', marginBottom: '1.25rem' },
//   retryBtn:        { background: 'none', border: 'none', color: '#dc2626', fontWeight: 600, cursor: 'pointer', fontSize: 13 },
//   metricsGrid:     { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 12, marginBottom: '1.25rem' },
//   metricCard:      { background: '#fff', border: '1px solid #f1f5f9', borderRadius: 14, padding: '16px 18px', boxShadow: '0 1px 3px rgba(0,0,0,.04)' },
//   metricTop:       { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 },
//   metricLabel:     { fontSize: 11, color: '#94a3b8', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase' },
//   metricValue:     { fontSize: 24, fontWeight: 700, letterSpacing: '-0.5px', marginBottom: 4 },
//   metricSub:       { fontSize: 12, color: '#94a3b8' },
//   chartCard:       { background: '#fff', border: '1px solid #f1f5f9', borderRadius: 14, padding: '16px 18px', marginBottom: '1.25rem', boxShadow: '0 1px 3px rgba(0,0,0,.04)' },
//   chartHeader:     { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 },
//   chartTitle:      { fontSize: 13, fontWeight: 600, color: '#334155' },
//   legend:          { display: 'flex', alignItems: 'center', fontSize: 12, color: '#64748b', gap: 4 },
//   legendDot:       { width: 8, height: 8, borderRadius: '50%', display: 'inline-block', marginRight: 4 },
//   chartWrap:       { overflowX: 'auto' },
//   chartBars:       { display: 'flex', alignItems: 'flex-end', gap: 6, minHeight: 120, height: 120, minWidth: 300 },
//   barGroup:        { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, height: '100%', cursor: 'default' },
//   barStack:        { width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', gap: 1 },
//   barSettled:      { background: '#16a34a', borderRadius: '3px 3px 0 0', transition: 'height .3s', minHeight: 2 },
//   barPending:      { background: '#eab308', borderRadius: '3px 3px 0 0', transition: 'height .3s', minHeight: 1 },
//   barLabel:        { fontSize: 10, color: '#94a3b8', whiteSpace: 'nowrap' },
//   tableCard:       { background: '#fff', border: '1px solid #f1f5f9', borderRadius: 14, boxShadow: '0 1px 3px rgba(0,0,0,.04)', overflow: 'hidden' },
//   tableTopRow:     { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', borderBottom: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 10 },
//   tabs:            { display: 'flex', gap: 4 },
//   tab:             { padding: '5px 14px', borderRadius: 20, fontSize: 12, fontWeight: 500, border: 'none', background: 'transparent', color: '#64748b', cursor: 'pointer' },
//   tabActive:       { background: '#f1f5f9', color: '#0f172a', fontWeight: 600 },
//   pageSizeRow:     { display: 'flex', alignItems: 'center', gap: 8 },
//   pageSizeLabel:   { fontSize: 12, color: '#94a3b8' },
//   select:          { border: '1px solid #e2e8f0', borderRadius: 7, padding: '4px 8px', fontSize: 12, color: '#0f172a', background: '#fff', cursor: 'pointer' },
//   tableWrap:       { overflowX: 'auto' },
//   table:           { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
//   th:              { padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#94a3b8', letterSpacing: '0.4px', textTransform: 'uppercase', borderBottom: '1px solid #f1f5f9', background: '#fafafa', whiteSpace: 'nowrap' },
//   td:              { padding: '12px 16px', borderBottom: '1px solid #f8fafc', verticalAlign: 'middle' },
//   tr:              { transition: 'background .1s' },
//   mono:            { fontFamily: "'JetBrains Mono', monospace", fontSize: 11 },
//   badge:           { display: 'inline-block', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600 },
//   methodChip:      { display: 'inline-block', padding: '2px 7px', borderRadius: 5, fontSize: 11, fontWeight: 600, background: '#f1f5f9', color: '#475569', marginRight: 4 },
//   empty:           { textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '2rem' },
//   pagination:      { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 8 },
//   paginationInfo:  { fontSize: 12, color: '#94a3b8' },
//   paginationBtns:  { display: 'flex', gap: 4, alignItems: 'center' },
//   pgBtn:           { padding: '5px 11px', fontSize: 12, fontWeight: 500, border: '1px solid #e2e8f0', borderRadius: 7, background: '#fff', color: '#475569', cursor: 'pointer' },
//   pgBtnActive:     { background: '#0f172a', color: '#fff', borderColor: '#0f172a' },
//   pgEllipsis:      { padding: '5px 4px', fontSize: 12, color: '#94a3b8' },
//   // Modal
//   modalOverlay:    { position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
//   modal:           { background: '#fff', borderRadius: 16, width: 400, maxWidth: '90vw', boxShadow: '0 24px 48px rgba(0,0,0,.12)' },
//   modalHeader:     { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px 0' },
//   modalTitle:      { fontSize: 16, fontWeight: 700, color: '#0f172a' },
//   closeBtn:        { background: 'none', border: 'none', fontSize: 16, color: '#94a3b8', cursor: 'pointer', lineHeight: 1 },
//   modalBody:       { padding: '16px 24px' },
//   availRow:        { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', marginBottom: 16 },
//   availLabel:      { fontSize: 12, color: '#15803d', fontWeight: 600 },
//   availAmt:        { fontSize: 18, fontWeight: 700, color: '#166534' },
//   inputLabel:      { fontSize: 12, color: '#64748b', fontWeight: 600, display: 'block', marginBottom: 6 },
//   inputWrap:       { display: 'flex', alignItems: 'center', border: '1.5px solid #e2e8f0', borderRadius: 10, overflow: 'hidden', background: '#fff' },
//   inputPrefix:     { padding: '0 12px', fontSize: 14, color: '#94a3b8', fontWeight: 600 },
//   input:           { flex: 1, border: 'none', padding: '11px 12px 11px 0', fontSize: 15, fontWeight: 600, color: '#0f172a', outline: 'none', background: 'transparent', width: '100%' },
//   errorText:       { fontSize: 12, color: '#dc2626', marginTop: 6 },
//   modalNote:       { fontSize: 12, color: '#94a3b8', marginTop: 12 },
//   modalFooter:     { display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '0 24px 20px' },
//   btnSecondary:    { padding: '9px 18px', borderRadius: 9, fontSize: 13, fontWeight: 600, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer' },
//   btnPrimary:      { padding: '9px 18px', borderRadius: 9, fontSize: 13, fontWeight: 600, border: 'none', background: '#15803d', color: '#fff', cursor: 'pointer' },
//   // Toast
//   toast:           { position: 'fixed', bottom: 24, right: 24, display: 'flex', alignItems: 'center', gap: 10, padding: '12px 18px', borderRadius: 12, fontSize: 13, fontWeight: 600, boxShadow: '0 8px 24px rgba(0,0,0,.12)', zIndex: 2000, animation: 'fadeInUp .25s ease' },
//   toastSuccess:    { background: '#166534', color: '#fff' },
//   toastError:      { background: '#dc2626', color: '#fff' },
// };

// export default PaymentGatewaySettlement;


import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import {
  ArrowDownToLine, CircleCheck, CircleAlert, Landmark, Info, X,
} from 'lucide-react';
import { host } from '../script/variables';
import '../style/PaymentGatewaySettlement.css';

// ─── Formatters ───────────────────────────────────────────────────────────────
const fmt = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n ?? 0);

const fmtDate = (s) =>
  new Date(s).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
  });

const fmtShortDate = (s) =>
  new Date(s).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });

// ─── Axios instance with partner token ───────────────────────────────────────
// Partner token is read from localStorage (set at login time).
// Key name: 'partnertoken' — adjust to match your auth store/context.
const getpartnertoken = () =>
  localStorage.getItem('partnertoken') || sessionStorage.getItem('partnertoken') || '';

const authAxios = axios.create();

// Attach token on every request; re-reads storage so it always uses latest value
authAxios.interceptors.request.use((config) => {
  const token = getpartnertoken();
  if (token) config.headers['Authorization'] = `${token}`;
  return config;
});

// Redirect to login on 401
authAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Adjust redirect path to match your router setup
      window.location.href = '/partner/login';
    }
    return Promise.reject(err);
  }
);

// ─── API factory — cafeId is baked in per component mount ────────────────────
// All payloads go in the request body (POST), never in query params.
const BASE = `${host}/payment/settlement`;

const makeApi = (cafeId) => ({
  summary: (payload) => authAxios.post(`${BASE}/summary`, { ...payload, cafeId }),
  withdraw: (amount)  => authAxios.post(`${BASE}/withdraw`, { amount, cafeId }),
});

// ─── Sparkline SVG ────────────────────────────────────────────────────────────
// Dynamic path geometry can't live in a static CSS class, so the drawn path
// itself stays inline while every other visual property is a CSS variable.
const Sparkline = ({ data = [], color = 'var(--pg-accent)', height = 36 }) => {
  if (!data.length) return null;
  const W = 120, H = height;
  const vals = data.map((d) => d.settled + d.pending);
  const max = Math.max(...vals, 1);
  const pts = vals.map((v, i) => {
    const x = (i / (vals.length - 1 || 1)) * W;
    const y = H - (v / max) * (H - 4);
    return `${x},${y}`;
  });
  const area = `M${pts.join(' L')} L${W},${H} L0,${H} Z`;
  const line = `M${pts.join(' L')}`;
  const gradId = `pg-spark-${Math.abs(color.split('').reduce((a, c) => a + c.charCodeAt(0), 0))}`;
  return (
    <svg width={W} height={H} className="pg-sparkline">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.18" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gradId})`} />
      <path d={line} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// ─── BarChart ─────────────────────────────────────────────────────────────────
const BarChart = ({ data = [] }) => {
  if (!data.length) return <p className="pg-empty">No chart data for this period yet.</p>;
  const max = Math.max(...data.map((d) => d.settled + d.pending), 1);
  return (
    <div className="pg-chart-wrap">
      <div className="pg-chart-bars">
        {data.map((d, i) => {
          const total = d.settled + d.pending;
          const sh = ((d.settled / max) * 100).toFixed(1);
          const ph = ((d.pending / max) * 100).toFixed(1);
          return (
            <div key={i} className="pg-bar-group" title={`${fmtShortDate(d.date + 'T00:00:00')}\nSettled: ${fmt(d.settled)}\nPending: ${fmt(d.pending)}`}>
              <div className="pg-bar-stack">
                <div className="pg-bar-spacer" />
                <div className="pg-bar-pending" style={{ height: `${ph}%` }} />
                <div className="pg-bar-settled" style={{ height: `${sh}%` }} />
              </div>
              <span className="pg-bar-label">{fmtShortDate(d.date + 'T00:00:00')}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ─── Badge ────────────────────────────────────────────────────────────────────
// Icon + word together, never color alone, so status is clear at a glance.
const Badge = ({ status }) => {
  const cfg = {
    settled: { Icon: CircleCheck, label: 'Settled' },
    pending: { Icon: CircleAlert, label: 'Pending' },
  }[status] ?? { Icon: Info, label: '—' };
  return (
    <span className={`pg-badge pg-badge--${status ?? 'unknown'}`}>
      <cfg.Icon size={13} strokeWidth={2.4} />
      {cfg.label}
    </span>
  );
};

// ─── Metric Card ──────────────────────────────────────────────────────────────
const MetricCard = ({ label, value, sub, tone = 'neutral', chart }) => (
  <div className="pg-metric-card">
    <div className="pg-metric-top">
      <span className="pg-metric-label">{label}</span>
      {chart && <Sparkline data={chart} color={`var(--pg-tone-${tone})`} />}
    </div>
    <div className={`pg-metric-value pg-metric-value--${tone}`}>{value}</div>
    {sub && <div className="pg-metric-sub">{sub}</div>}
  </div>
);

// ─── Skeleton ─────────────────────────────────────────────────────────────────
const Skeleton = ({ w = '100%', h = 16 }) => (
  <div className="pg-skeleton" style={{ width: w, height: h }} />
);

// ─── Modal ────────────────────────────────────────────────────────────────────
const WithdrawModal = ({ available, onClose, onSuccess, api }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleSubmit = async () => {
    const val = parseFloat(amount);
    if (!val || val <= 0) return setError('Please enter a valid amount');
    if (val > available) return setError(`This is more than your available balance of ${fmt(available)}`);
    setError('');
    setLoading(true);
    try {
      const { data } = await api.withdraw(val);
      onSuccess(data.data);
    } catch (e) {
      setError(e?.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => { if (e.key === 'Enter') handleSubmit(); if (e.key === 'Escape') onClose(); };

  return (
    <div className="pg-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pg-modal" role="dialog" aria-modal="true" aria-label="Request withdrawal">
        <div className="pg-modal-header">
          <span className="pg-modal-title">Move money to my bank</span>
          <button className="pg-close-btn" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <div className="pg-modal-body">
          <div className="pg-avail-row">
            <span className="pg-avail-label">Available to withdraw</span>
            <span className="pg-avail-amt">{fmt(available)}</span>
          </div>
          <label className="pg-input-label" htmlFor="pg-withdraw-amount">How much do you want to withdraw?</label>
          <div className="pg-input-wrap">
            <span className="pg-input-prefix">₹</span>
            <input
              id="pg-withdraw-amount"
              ref={inputRef}
              type="number"
              min="1"
              max={available}
              step="1"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => { setAmount(e.target.value); setError(''); }}
              onKeyDown={handleKey}
              className="pg-input"
            />
          </div>
          {error && <p className="pg-error-text">{error}</p>}
          <p className="pg-modal-note">Money usually reaches your bank account in 1–2 business days.</p>
        </div>
        <div className="pg-modal-footer">
          <button className="pg-btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="pg-btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Submitting…' : 'Confirm withdrawal'}
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Toast ────────────────────────────────────────────────────────────────────
const Toast = ({ message, type = 'success', onDone }) => {
  useEffect(() => { const t = setTimeout(onDone, 3500); return () => clearTimeout(t); }, [onDone]);
  return (
    <div className={`pg-toast pg-toast--${type}`}>
      {type === 'success' ? <CircleCheck size={16} /> : <CircleAlert size={16} />}
      <span>{message}</span>
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const FILTERS = [
  { key: 'today',     label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'week',      label: 'This week' },
  { key: 'month',     label: 'This month' },
  { key: 'custom',    label: 'Custom' },
];

const STATUS_TABS = [
  { key: 'all',     label: 'All' },
  { key: 'settled', label: 'Settled' },
  { key: 'pending', label: 'Pending' },
];

const PAGE_SIZES = [10, 20, 50];

const PaymentGatewaySettlement = ({ cafeid }) => {
  // ── cafeId comes from parent prop: <PaymentGatewaySettlement cafeid={cafeid} />
  const cafeId = cafeid;

  // ── Memoised API instance — recreated only when cafeId changes
  const api = React.useMemo(() => makeApi(cafeId), [cafeId]);

  const [period, setPeriod]         = useState('week');
  const [from, setFrom]             = useState('');
  const [to, setTo]                 = useState('');
  const [status, setStatus]         = useState('all');
  const [page, setPage]             = useState(1);
  const [limit, setLimit]           = useState(20);
  const [data, setData]             = useState(null);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');
  const [showModal, setShowModal]   = useState(false);
  const [toast, setToast]           = useState(null);

  // ── Fetch — defined unconditionally; guard inside callback
  const fetchData = useCallback(async () => {
    if (!cafeId) return;
    if (period === 'custom' && (!from || !to)) return;
    setLoading(true);
    setError('');
    try {
      const params = { period, status, page, limit };
      if (period === 'custom') { params.from = from; params.to = to; }
      const res = await api.summary(params);
      setData(res.data.data);
    } catch (e) {
      setError(e?.response?.data?.message || 'Could not load settlement data. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [cafeId, period, from, to, status, page, limit]);

  useEffect(() => { setPage(1); }, [period, from, to, status, limit]);
  useEffect(() => { fetchData(); }, [fetchData]);

  // ── Guard rendered AFTER all hooks — never early-return before hooks
  if (!cafeId) {
    return (
      <div className="pg-page-error">
        No cafe ID provided. Pass <code>cafeid</code> as a prop.
      </div>
    );
  }

  const handlePeriod = (p) => { setPeriod(p); if (p !== 'custom') { setFrom(''); setTo(''); } };

  const handleWithdrawSuccess = (result) => {
    setShowModal(false);
    setToast({ type: 'success', message: `Withdrawal of ${fmt(result.requestedAmount)} submitted!` });
    fetchData();
  };

  const { stats = {}, transactions = [], pagination = {}, chartData = [] } = data ?? {};

  return (
    <div className="pg-page">
      {/* ── Header ── */}
      <div className="pg-header">
        <div className="pg-header-copy">
          <div className="pg-header-eyebrow">
            <Landmark size={16} strokeWidth={2.2} />
            <span>Bank Settlement</span>
          </div>
          <p className="pg-page-subtitle">Money collected online through Cashfree, and when it reaches your bank</p>
        </div>
        <button
          className="pg-withdraw-trigger"
          onClick={() => setShowModal(true)}
          disabled={!stats.availableBalance}
          title={!stats.availableBalance ? 'No balance available yet' : ''}
        >
          <ArrowDownToLine size={16} strokeWidth={2.2} />
          Withdraw to bank
        </button>
      </div>

      {/* ── Period filters ── */}
      <div className="pg-filter-row" role="group" aria-label="Time period">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            className={`pg-chip ${period === f.key ? 'pg-chip--active' : ''}`}
            onClick={() => handlePeriod(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* ── Custom date range ── */}
      {period === 'custom' && (
        <div className="pg-date-row">
          <div className="pg-date-field">
            <label className="pg-date-label" htmlFor="pg-from-date">From</label>
            <input id="pg-from-date" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="pg-date-input" max={to || undefined} />
          </div>
          <div className="pg-date-sep">→</div>
          <div className="pg-date-field">
            <label className="pg-date-label" htmlFor="pg-to-date">To</label>
            <input id="pg-to-date" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="pg-date-input" min={from || undefined} />
          </div>
        </div>
      )}

      {/* ── Error ── */}
      {error && (
        <div className="pg-error-banner">
          <span><CircleAlert size={15} /> {error}</span>
          <button className="pg-retry-btn" onClick={fetchData}>Retry</button>
        </div>
      )}

      {/* ── Metric cards ── */}
      <div className="pg-metrics-grid">
        {loading ? (
          [1, 2, 3, 4].map((k) => (
            <div key={k} className="pg-metric-card">
              <Skeleton w="60%" h={11} />
              <Skeleton w="80%" h={28} />
              <Skeleton w="40%" h={11} />
            </div>
          ))
        ) : (
          <>
            <MetricCard label="Total collected"      value={fmt(stats.totalCollected)}   sub={`${stats.totalTransactions ?? 0} payments`} tone="neutral" chart={chartData} />
            <MetricCard label="Settled to your bank"  value={fmt(stats.settledAmount)}    sub={`${stats.settledCount ?? 0} payments`}       tone="success" chart={chartData} />
            <MetricCard label="Still processing"      value={fmt(stats.pendingAmount)}    sub={`${stats.pendingCount ?? 0} payments`}       tone="warning" chart={chartData} />
            <MetricCard
              label={<>Available to withdraw <span className="pg-info-hint" title="This balance is after the payment gateway's own ~3% processing fee.">
                <Info size={12} strokeWidth={2.4} />
              </span></>}
              value={fmt(stats.availableBalance)}
              sub="After gateway fee (~3%)"
              tone="accent"
              chart={chartData}
            />
          </>
        )}
      </div>

      {/* ── Bar chart ── */}
      {!loading && chartData.length > 0 && (
        <div className="pg-chart-card">
          <div className="pg-chart-header">
            <span className="pg-chart-title">Daily amount collected</span>
            <div className="pg-legend">
              <span className="pg-legend-item"><span className="pg-legend-dot pg-legend-dot--settled" />Settled</span>
              <span className="pg-legend-item"><span className="pg-legend-dot pg-legend-dot--pending" />Pending</span>
            </div>
          </div>
          <BarChart data={chartData} />
        </div>
      )}

      {/* ── Table ── */}
      <div className="pg-table-card">
        <div className="pg-table-top-row">
          <div className="pg-tabs" role="group" aria-label="Filter by settlement status">
            {STATUS_TABS.map((t) => (
              <button key={t.key} className={`pg-tab ${status === t.key ? 'pg-tab--active' : ''}`} onClick={() => setStatus(t.key)}>
                {t.label}
              </button>
            ))}
          </div>
          <div className="pg-page-size-row">
            <span className="pg-page-size-label">Rows</span>
            <select value={limit} onChange={(e) => setLimit(Number(e.target.value))} className="pg-select">
              {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
        </div>

        {/* Desktop table */}
        <div className="pg-table-wrap">
          <table className="pg-table">
            <thead>
              <tr>
                {['Order ID', 'Amount', 'Method', 'Payment ID', 'Completed at', 'Settlement'].map((h) => (
                  <th key={h} className="pg-th">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i}>
                    {[1, 2, 3, 4, 5, 6].map((c) => (
                      <td key={c} className="pg-td"><Skeleton w={c === 1 ? '90%' : c === 2 ? '50%' : '70%'} /></td>
                    ))}
                  </tr>
                ))
              ) : transactions.length === 0 ? (
                <tr>
                  <td colSpan={6} className="pg-td pg-td--empty">
                    No gateway payments found for this period
                  </td>
                </tr>
              ) : (
                transactions.map((p) => (
                  <tr key={p._id} className="pg-tr">
                    <td className="pg-td pg-mono pg-td--muted">{p.order_id}</td>
                    <td className="pg-td pg-td--amount">{fmt(p.totalAmount)}</td>
                    <td className="pg-td">
                      {Object.keys(p.paymentMethods ?? {}).map((m) => (
                        <span key={m} className="pg-method-chip">{m.toUpperCase()}</span>
                      ))}
                    </td>
                    <td className="pg-td pg-mono pg-td--muted">{p.cf_payment_id}</td>
                    <td className="pg-td pg-td--nowrap pg-td--muted">{fmtDate(p.payment_completion_time)}</td>
                    <td className="pg-td"><Badge status={p.gateway_settlement_status} /></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile card list */}
        {!loading && transactions.length > 0 && (
          <div className="pg-card-list">
            {transactions.map((p) => (
              <div key={p._id} className="pg-mini-card">
                <div className="pg-mini-top">
                  <span className="pg-mono pg-td--muted">{p.order_id}</span>
                  <span className="pg-td--amount">{fmt(p.totalAmount)}</span>
                </div>
                <div className="pg-mini-bottom">
                  <Badge status={p.gateway_settlement_status} />
                  <span className="pg-mini-date">{fmtDate(p.payment_completion_time)}</span>
                </div>
                {Object.keys(p.paymentMethods ?? {}).length > 0 && (
                  <div>
                    {Object.keys(p.paymentMethods ?? {}).map((m) => (
                      <span key={m} className="pg-method-chip">{m.toUpperCase()}</span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {loading && (
          <div className="pg-card-list">
            {[1, 2, 3].map((k) => (
              <div key={k} className="pg-mini-card">
                <Skeleton w="70%" h={14} />
                <Skeleton w="40%" h={12} />
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {pagination.totalPages > 1 && (
          <div className="pg-pagination">
            <span className="pg-pagination-info">
              Showing {((page - 1) * limit) + 1}–{Math.min(page * limit, pagination.total)} of {pagination.total}
            </span>
            <div className="pg-pagination-btns">
              <button className="pg-pg-btn" disabled={!pagination.hasPrev || loading} onClick={() => setPage((p) => p - 1)}>← Prev</button>
              {Array.from({ length: pagination.totalPages }, (_, i) => i + 1)
                .filter((p) => p === 1 || p === pagination.totalPages || Math.abs(p - page) <= 1)
                .reduce((acc, p, i, arr) => {
                  if (i > 0 && p - arr[i - 1] > 1) acc.push('…');
                  acc.push(p);
                  return acc;
                }, [])
                .map((p, i) =>
                  p === '…'
                    ? <span key={`e${i}`} className="pg-pg-ellipsis">…</span>
                    : <button key={p} className={`pg-pg-btn ${p === page ? 'pg-pg-btn--active' : ''}`} onClick={() => setPage(p)}>{p}</button>
                )}
              <button className="pg-pg-btn" disabled={!pagination.hasNext || loading} onClick={() => setPage((p) => p + 1)}>Next →</button>
            </div>
          </div>
        )}
      </div>

      {/* ── Withdraw modal ── */}
      {showModal && (
        <WithdrawModal
          available={stats.availableBalance ?? 0}
          onClose={() => setShowModal(false)}
          onSuccess={handleWithdrawSuccess}
          api={api}
        />
      )}

      {/* ── Toast ── */}
      {toast && <Toast {...toast} onDone={() => setToast(null)} />}
    </div>
  );
};

export default PaymentGatewaySettlement;